// extracted by mini-css-extract-plugin
module.exports = {"upload":"styles_upload__35nfJ","uploadContainer":"styles_uploadContainer__1YMHy"};